export default "__VITE_ASSET__BihHOAYH__"